import { AppointmentTypeGroup } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/bookable_appointment_type.pb';
import { useTranslation } from '@frontend/i18n';
import { ModalControlModalProps, Modal, Text, RadioCardField, useFormField } from '@frontend/design-system';
import { appointmentTypeString } from '../../../utils/translation-helpers';
import { IndividualPrepayAmountUpdate } from './IndividualPrepayAmountUpdate';
import { SamePrepayAmountUpdate } from './SamePrepayAmountUpdate';

type AppointmentTypesBulkPrepaymentEditModalProps = {
  appointmentTypeGroups: AppointmentTypeGroup[];
  locationId: string;
} & ModalControlModalProps;

export const AppointmentTypesBulkPrepaymentEditModal = ({
  appointmentTypeGroups,
  locationId,
  ...modalProps
}: AppointmentTypesBulkPrepaymentEditModalProps) => {
  const { t } = useTranslation('scheduleServiceTypes');
  const radioCardFieldProps = useFormField({ type: 'radio', value: 'edit-individually' });
  const shouldEditIndividually = radioCardFieldProps.value === 'edit-individually';

  const radioCardGroup = (
    <>
      <Text>{appointmentTypeString(appointmentTypeGroups.length) + ' ' + t('Selected')}</Text>
      <RadioCardField name='edit-type' {...radioCardFieldProps}>
        <RadioCardField.Option
          key={'edit-individually'}
          value={`edit-individually`}
          title={t('Edit Individually')}
          description={t('Set a unique pre-pay amount for each selected appointment type')}
        />
        <RadioCardField.Option
          key={'set-same-amount'}
          value={`set-same-amount`}
          title={t('Set Same Amount')}
          description={t('Apply one pre-pay amount to all selected appointment types')}
        />
      </RadioCardField>
    </>
  );

  return (
    <Modal {...modalProps} maxWidth={600}>
      <Modal.Header onClose={() => modalProps.onClose()}>{t('Update Pre-Pay Amounts')}</Modal.Header>
      {shouldEditIndividually ? (
        <IndividualPrepayAmountUpdate
          appointmentTypeGroups={appointmentTypeGroups}
          locationId={locationId}
          modalProps={modalProps}
        >
          {radioCardGroup}
        </IndividualPrepayAmountUpdate>
      ) : (
        <SamePrepayAmountUpdate
          appointmentTypeGroups={appointmentTypeGroups}
          locationId={locationId}
          modalProps={modalProps}
        >
          {radioCardGroup}
        </SamePrepayAmountUpdate>
      )}
    </Modal>
  );
};
